// @flow

import type {Action} from '../../types'
import type {MapState} from '../types'
import type {SetGoogleMapPayload} from '../actions/setGoogleMap'

export function setGoogleMapReducer(state: MapState, action: Action<SetGoogleMapPayload>): MapState {

  return {
    ...state,
    googleMap: action.payload.map,
  }
}
